// Swiper is imported already

if (!customElements.get('product-detail-swiper')) {
  class ProductDetailSwiper extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-product-detail-swiper]');

      this.swiperOptions = {
        direction: 'horizontal',
      };

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
      });
    }
  }

  customElements.define('product-detail-swiper', ProductDetailSwiper);
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    /**
     * constructor
     */
    constructor() {
      super();
      this.productForm = this.querySelector('product-form');
      this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
      this.quantityInput = this.querySelector('quantity-input');
      this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
      this.quantityInputElement?.addEventListener('change', () => {
        this.handleQuantityInput();
      });

      this.handleAnimatedSubmit();
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput() {
      this.productFormQuantity.value = this.quantityInputElement.value;
    }

    /**
     * observerCallback
     * @param {Object} entries
     */
    observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.hideButton();
        } else if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          this.showButton();
        }
      });
    };

    showButton() {
      const content = this.querySelector('[data-add-to-cart-behavior]').cloneNode(true);
      this.animatedAddToCartHolder.setAttribute('aria-expanded', 'true');
      this.animatedAddToCartHolder.replaceChildren(content);
    }

    hideButton() {
      this.animatedAddToCartHolder.setAttribute('aria-expanded', 'false');
      this.animatedAddToCartHolder.innerHTML = '';
    }

    /**
     * handleAnimatedSubmit
     */
    handleAnimatedSubmit() {
      // Stop if IntersectionObserver is not supported by the browser
      if (!('IntersectionObserver' in window)) return;

      this.submitButton = this.querySelector('[data-add-to-cart-behavior]');
      this.animatedAddToCartHolder = this.querySelector('[data-add-to-cart-holder]');

      let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      };

      // Create the observer
      let observer = new IntersectionObserver(this.observerCallback, options);
      // Watch element
      observer.observe(this.querySelector('product-form'));
    }
  }
  customElements.define('product-info', ProductInfo);
}
